<template>
  <div class="app-store-index">
    <el-tabs v-model="activeNameTab" class="topTabIndex" @tab-click="handleTabClick">
      <el-tab-pane label="首页" name="first"></el-tab-pane>
      <!-- <el-tab-pane label="台州市美丽城镇智慧平台" name="second"> -->
    </el-tab-pane>
        <div class="container" v-show="activeNameTab === 'first'">
          <div class="bg-grey">
            <!--开始部分-->
            <div class="top">
              <!--所有类目-->
              <div class="category">
                <div class="title" @click="$router.push('/application/list/-1')">
                  <span class="title-all">所有类目 {{totalNum > 0 ? `(${totalNum})` : ''}}</span>
                  <div class="title-arrow"><el-image style="height: 8px" :src="arrowUrl" /></div>
                </div>
                <div class="detail">
                  <div class="content" v-for="(item, index) in tagList" :key="index">
                    <div class="hover-content" v-if="tagList && tagList.length !== 0">
                      <div class="parent-cate">
                        <div class="point"></div>
                        <div class="name" style="">{{ item.name }}{{ item.applyAndSolutionCount > 0 ? `(${item.applyAndSolutionCount})` : '' }}</div>
                      </div>
                      <div class="child-cate">
                        <div
                          class="child-name"
                          v-for="(children, indexItem) in item.children"
                          :key="indexItem"
                          @click="goApplication(children.id)"
                        >
                          {{ children.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--轮播图-->
              <div class="banner">
                <el-carousel
                  ref="bannerSwiper"
                  height="100%"
                  style="height: 100%"
                  :autoplay="false"
                  indicator-position="none"
                  arrow="never"
                  @change="bannerChange"
                >
                  <el-carousel-item v-for="(banner, index) in bannerPage" :key="index">
                    <el-image
                      fit="cover"
                      @click="goBanner(banner.linkUrl)"
                      :src="banner.imageUrl"
                      style="height: 100%"
                    />
                  </el-carousel-item>
                </el-carousel>
                <div class="swiper-pagination" v-show="bannerPage.length > 1">
                  <div
                    class="progress"
                    :style="i === swiperRealIndex ? { width: '240px' } : { width: '100px' }"
                    v-for="(banner, i) in bannerPage"
                    :key="i"
                    @click="toSlider(i)"
                  >
                    <el-progress
                      color="#FFF"
                      :percentage="i === swiperRealIndex ? swiperPercent : 0"
                      :stroke-width="2"
                      :show-text="false"
                    ></el-progress>
                  </div>
                </div>
              </div>
            </div>
            <!--精品推荐-->
            <div class="quality">
              <div class="title">精选推荐</div>
              <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="tabChange">
                  <el-tab-pane label="最新" name="new">
                    <div class="show-card">
                      <div
                        class="card"
                        v-for="(item, index) in qualityList.slice(0, 8)"
                        :key="index"
                        @click="goAppDetail(item.applyLibraryId)"
                      >
                        <div class="card-image" :style="{ backgroundColor: '#fff' }">
                          <img :src="item.applyImg" rel="no-referrer" style="width:100%;height:100%;" />
                        </div>
                        <div class="card-detail">
                          <div class="card-top">
                            <div class="detail-title">{{ item.applyName }}</div>
                            <div class="card-arrow"><el-image :src="arrowUrl2" /></div>
                          </div>
                          <div class="detail-desc">{{ item.applyMessage }}</div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="最热" name="hot">
                    <div class="show-card">
                      <div
                        class="card"
                        v-for="(item, index) in qualityList.slice(0, 8)"
                        :key="index"
                        @click="goAppDetail(item.applyLibraryId)"
                      >
                        <div class="card-image" :style="{ backgroundColor: '#fff' }">
                          <img :src="item.applyImg" rel="no-referrer" style="width:100%;height:100%;" />
                        </div>
                        <div class="card-detail">
                          <div class="card-top">
                            <div class="detail-title">{{ item.applyName }}</div>
                            <div class="card-arrow"><el-image :src="arrowUrl2" /></div>
                          </div>
                          <div class="detail-desc">{{ item.applyMessage }}</div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
          <!--标杆案例-->
          <div :class="(caseList && caseList.length !== 0 )? 'bg-white' : 'bg-none-grey'">
            <div style="height: 1px"></div>
            <Loader v-if="caseLoading" />
            <div class="case" v-if="caseList && caseList.length !== 0 && !caseLoading">
              <div class="title">优质解决方案</div>
              <div class="show-more">
                <div class="content" @click="goCase">查看更多</div>
                <div><el-image :src="arrowUrl3" /></div>
              </div>
              <div class="case-detail">
                <div
                  class="content"
                  v-for="(caseItem, index) in caseList.slice(0, 3)"
                  :key="index"
                  @click="goDetail(caseItem)"
                >
                  <div class="case-image">
                    <!-- <el-image :src="caseItem.imageUrl" style="width: 380px; height: 255px" /> -->
                    <el-image :src="caseItem.bannerUrl" style="width: 100%; height: 100%" />
                  </div>
                  <!-- <div class="case-tags">
                    <div v-if="caseItem.labels">
                      <el-tag
                        v-for="(label, labelIndex) in caseItem.labels.split(',')"
                        :key="labelIndex"
                        >{{ label }}</el-tag
                      >
                    </div>
                  </div> -->
                  <div class="case-title">{{ caseItem.solutionName }}</div>
                  <div class="case-desc">{{ caseItem.solutionDesc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Taizhou v-show="activeNameTab === 'second'"></Taizhou>
      
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import arrowUrl from './assets/arrow.png'
import arrowUrl2 from './assets/arrow2.png'
import arrowUrl3 from './assets/arrow3.png'
import bookUrl from './assets/book.png'
import picUrl from './assets/pic.png'
import bannerUrl from './assets/banner.png'
import Loader from '@/components/loading/loader'
import Taizhou from './../taizhou/index.vue'
let percentTimer = null

export default {
  data () {
    return {
      activeName: 'new',
      activeNameTab: 'first',
      arrowUrl,
      arrowUrl2,
      arrowUrl3,
      bookUrl,
      picUrl,
      bannerUrl,
      cardHoverType: '',
      cardHoverIndex: -1,
      caseHoverIndex: -1,
      swiperRealIndex: null,
      swiperPercent: 0,
      qualityParams: {
        type: 2
      },
      categoryId: -1,
      // code: '',
      searchParams: {
        p: 1,
        c: 5,
        id: 0
      },
      caseLoading: true
    }
  },
  components: {
    Loader,
    Taizhou
  },
  computed: {
    ...mapState({
      townId: state => state.user.townId,
      tagList: state => {
        let arr = state.home.tagList.sort((a, b) => a.orderNum - b.orderNum)
        arr.map(item => item.children.sort((a, b) => a.orderNum - b.orderNum))
        return arr
      },
      caseList: state => state.home.caseList,
      qualityList: state => state.home.qualityList,
      // bannerList: state => state.home.bannerList,
      channelByCode: state => state.home.channelByCode,
      bannerPage: state => state.home.bannerPage,
      code: state => state.home.code
    }),
    hasKeyword () {
      return this.$route.query.keyword
    },
    swiper () {
      let swiperRef = this.$refs.mySwiper
      return swiperRef.$swiper
    },
    totalNum() {
      let total = 0
      for (let i = 0; i < this.tagList.length; i++) {
        total = total + this.tagList[i].applyAndSolutionCount
      }
      return total
    }
  },
  watch: {
    townId () {
      this.fetch()
    },
    channelByCode () {
      this.createdFunction()
    },
    '$route.query' () {
      if (this.$route.query.tab) {
        this.activeNameTab = this.$route.query.tab
      } else {
        this.activeNameTab = 'first'
      }
    }
  },
  methods: {
    ...mapActions('home', ['fetchCaseList', 'fetchTagList', 'getQualityList', 'getBannerList', 'getBannerPage']),
    ...mapActions('login', ['loginByToken']),
    ...mapMutations('home', ['updateSearchValue']),
    fetch () {
      if (this.code && this.channelByCode) {
        this.searchParams.assignId = this.channelByCode.id
        this.getBannerPage(this.searchParams)
      } else {
        this.searchParams.assignId = 0
        this.getBannerPage(this.searchParams)
      }
      this.fetchCaseList().then(res => {
        this.caseLoading = false
      })
      this.fetchTagList(this.townId)
      this.getQualityList(this.qualityParams)
    },
    // 头部tab切换
    handleTabClick(e) {
      console.log(e)
      if (e.index > 0) {
        this.$router.replace({
          path: '/',
          query: {
            tab: e.name
          }
        })
      } else {
        this.$router.replace({
          path: '/'
        })
      }
    },
    tabChange (e) {
      console.log()
      if (e.index === '0') {
        this.qualityParams.type = 2
      } else if (e.index === '1') {
        this.qualityParams.type = 1
      }
      this.getQualityList(this.qualityParams)
    },
    bannerChange (index, oldIndex) {
      this.swiperRealIndex = index
      if (percentTimer) {
        clearInterval(percentTimer)
      }
      this.swiperPercent = 0
      percentTimer = setInterval(() => {
        let newPercent = this.swiperPercent
        newPercent += 0.5
        if (newPercent >= 100) {
          newPercent = 100
          clearInterval(percentTimer)
          this.swiperPercent = newPercent
          this.$refs.bannerSwiper.next()
          return
        }
        this.swiperPercent = newPercent
      }, 25)
    },
    toSlider (index) {
      this.$refs.bannerSwiper.setActiveItem(index)
      this.bannerChange(index)
    },
    goApplication (categoryId) {
      this.$router.push('/application/list/' + categoryId)
    },
    goCase () {
      this.$router.push('/case/list')
    },
    goDetail (item) {
      // this.$router.push(`/case/info/${id}`)
      this.$router.push({path: '/application/solutiondetail', query: {solutionId: item.solutionId, solutionRecordId: item.solutionRecordId}})
    },
    goBanner (url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    goAppDetail (appId) {
      this.$router.push(`/application/detail/${appId}`)
    },
    createdFunction () {
      if (this.$route.query.token) {
        this.loginByToken(this.$route.query.token)
      }
      // this.code = this.$route.query.code;
      this.fetch()
      this.updateSearchValue('')
      this.bannerChange(0)
    }
  },
  created () {
    if (this.$route.query.tab) {
      this.activeNameTab = this.$route.query.tab
    } else {
      this.activeNameTab = 'first'
    }
    if (!this.code) {
      this.createdFunction()
    }
  },
  destroyed () {
    clearInterval(percentTimer)
  }
}
</script>
<style lang="less">
.topTabIndex{
    > .el-tabs__header{
      margin: 0;
      background: #fff;
    }
    >.el-tabs__header .el-tabs__nav-wrap{
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 10px;
    }
    >.el-tabs__header .el-tabs__nav-wrap::after{
      display: none;
    }
    > .el-tabs__header .el-tabs__item{
      font-size: 20px;
    }
    > .el-tabs__header .el-tabs__active-bar{
      height: 4px;
    }
    > .el-tabs__header #tab-second{
      padding-left: 50px;
    }
  }
</style>
<style lang="less" scoped>
.app-store-index {
  background: #f5f5f5;
  color: #333;
  
}
.container {
  padding: 20px 0 0 0;
  .bg-grey,
  .bg-white {
    & > div {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .bg-white {
    background-color: white;
    margin-top: 50px;
    padding-bottom: 150px;
  }
  .bg-none-grey{
    margin-top: 50px;
    padding-bottom: 150px;
  }
}
//开始部分
.container .top {
  display: flex;
  & > div {
    display: inline-block;
  }
  //类目
  .category {
    width: 276px;
    height: 396px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    margin-right: 32px;
    //类目标题
    .title {
      margin: 30px 0 20px 30px;
      cursor: pointer;
      .title-all {
        font-size: 20px;
        font-weight: 600;
        height: 20px;
        display: inline-block;
        line-height: 20px;
      }
      .title-arrow {
        height: 20px;
        display: inline-block;
        vertical-align: top;
      }
    }
    //具体类目
    .detail {
      margin-left: 21px;
      div {
        display: inline-block;
        cursor: pointer;
      }
      .content {
        width: 127px;
        margin-bottom: 17px;
        position: relative;
        .name {
          color: #333;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          height: 22px;
          line-height: 22px;
          font-weight: 400;
        }
        .point {
          width: 3px;
          height: 3px;
          background: #0091ff;
          vertical-align: middle;
          margin-right: 6px;
        }
        .hover-content {
          .child-cate {
            display: none;
          }
          &:hover {
            position: absolute;
            top: -8px;
            left: -8px;
            width: 215px;
            background: #ffffff;
            box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.08);
            z-index: 5;
            .parent-cate {
              margin: 10px 0 14px 8px;
            }
            .name {
              height: 22px;
              font-size: 16px;
              font-weight: 600;
              color: #2795e9;
              line-height: 22px;
            }
            .child-cate {
              display: block;
              margin: 0 0 0 18px;
            }
            .child-name {
              width: 50%;
              margin: 0 0 10px 0;
              height: 18px;
              font-size: 13px;
              font-weight: 400;
              color: #333333;
              line-height: 18px;
              &:hover {
                color: #2795e9;
              }
            }
            //.child-name end
          }
          //&:hover end
        }
        //.hover-content end
      }
      //.content end
    }
    //.detail end
  }
  //banner
  .banner {
    width: 891px;
    height: 396px;
    position: relative;
    cursor: pointer;
    .swiper-pagination {
      width: 100%;
      bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .progress {
        margin-right: 15px;
        transition: all 0.3s;
        cursor: pointer;
        height: 10px;
        display: flex;
        align-items: center;
      }
      .el-progress {
        width: 100%;
      }
    }
    /deep/ .el-progress-bar__outer {
      background: #4c4c4c;
      opacity: 0.2;
    }
    /deep/ .el-progress-bar__inner {
      transition: unset;
    }
  }
}
//精选推荐
.container .quality {
  .title {
    margin: 60px 0 21px;
    font-size: 34px;
    text-align: center;
    height: 56px;
    line-height: 56px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
  }
  .tabs {
    /deep/ .el-tabs__header{
      margin: 0 0 15px;
      background: none;
    }
    /deep/ .el-tabs__nav-wrap{
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 0;
    }
    /deep/ .el-tabs__nav-wrap::after{
      display: block;
    }
    /deep/ .el-tabs__content{
      padding: 0;
    }

    /deep/ .el-tabs__active-bar {
      background: #0091ff;
      height: 4px;
    }
    /deep/ .el-tabs__item.is-active {
      font-family: PingFangSC-Semibold;
    }
    /deep/ .el-tabs__item {
      &:hover {
        color: #0091ff;
      }
      margin: 0 0 10px 0;
      width: 150px;
      text-align: center;
      font-size: 24px;
      height: 33px;
      line-height: 33px;
      padding: 0;
      font-family: PingFangSC-Regular;
    }
    .show-card {
      margin-top: 25px;
      display: flex;
      flex-wrap: wrap;
      .card {
        display: flex;
        width: 274px;
        height: 102px;
        background: #ffffff;
        border: 1px solid #e4e4e4;
        margin: 0 32px 30px 0;
        &:nth-child(4n) {
          margin: 0;
        }
      }
      .card-image {
        padding: 10px;
        width: 50px;
        height: 50px;
        margin: 16px 10px 0 16px;
        display: flex;
        border: 1px solid #e4e4e4;
        border-radius: 14px;
        align-items: center;
        justify-content: center;
      }
      .card-detail {
        margin: 16px 12px 0 0;
        .detail-title {
          font-family: PingFangSC-Semibold;
          height: 25px;
          font-size: 18px;
          font-weight: 600;
          line-height: 25px;
          padding: 3px 0 8px;
        }
        .card-top {
          display: flex;
          justify-content: space-between;
        }
        .detail-desc {
          height: 34px;
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
          font-family: PingFangSC-Regular;
          width: 160px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .card-arrow {
        display: none;
        .el-image {
          padding-top: 10px;
        }
      }

      .card:hover {
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
        border: 1px solid #0091ff;
        cursor: pointer;
        .detail-title {
          color: #0091ff;
        }
        .card-arrow {
          display: block;
        }
      }
    }
  }
}
//标杆案例
.container .case {
  .title {
    margin: 74px 0 42px;
    font-size: 34px;
    text-align: center;
    height: 56px;
    line-height: 56px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
  }
  .show-more {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    .content {
      height: 33px;
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      line-height: 33px;
      font-family: PingFangSC-Regular;
    }
    .el-image {
      padding: 14px 0 0 9px;
    }
  }
  .case-detail {
    margin-top: 29px;
    display: flex;
    flex-wrap: wrap;
    .content {
      // width: 380px;
      width: 585px;
      // margin-right: 30px;
      /deep/ .el-image__inner {
        transition: all 0.6s;
      }
      &:last-child {
        margin: 0;
      }
      .case-image {
        // width: 380px;
        width: 100%;
        height: 220px;
      }
    }
    .content:nth-child(odd){
      margin-right: 28px;
    }
    .case-tags {
      margin-top: 12px;
      width: 380px;
      height: 25px;
      .el-tag {
        background: #f0f0f0;
        border-color: #fff;
        color: #a2a2a2;
        height: 25px;
        line-height: 22px;
        font-size: 14px;
        margin-right: 5px;
        font-family: PingFangSC-Regular;
      }
    }
    .case-title {
      margin-top: 30px;
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: #000000;
      line-height: 30px;
      font-family: PingFangSC-Medium;
    }
    .case-desc {
      margin-top: 20px;
      height: 56px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-family: PingFangSC-Regular;
    }
    .content:hover {
      cursor: pointer;
      /deep/ .el-image__inner {
        transform: scale(1.2);
        transition: all 0.6s;
      }
    }
  }
}
/deep/ .el-popover {
  top: 0 !important;
  left: 0 !important;
}
.el-popover {
  .popover-container {
    width: 100%;
    .popover-top {
      display: flex;
      align-items: center;
      margin-top: 4px;
      .point {
        width: 3px;
        height: 3px;
        background: #0091ff;
        vertical-align: middle;
        margin: 0 6px 0 10px;
      }
      .popover-title {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #2795e9;
        line-height: 22px;
      }
    }
    .children-list {
      margin: 8px 17px 0 17px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .children {
        width: 90px;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .children:nth-child(odd) {
        text-align: left;
      }
      .children:nth-child(even) {
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue